module.exports = __webpack_public_path__ + "img/noip.8b9a3480.png";